import React from 'react';
import BizzaPlyr from '@bizzabo/components/BizzaPlyr';
import { MutedPreviewOverlay, MuxPlayerWrapper as MuxPlayer } from '@bizzabo/broadcast';
import {VolumeMuteOutlineIcon} from '@bizzabo/icons';
import FeatureToggleUtils from 'FeatureToggleUtils';

const initialPlayerConfigs = {
    controls: ['play', 'play-large', 'mute', 'volume', 'rewind', 'fast-forward', 'progress', 'duration', 'captions', 'settings', 'pip', 'airplay', 'fullscreen'],
    settings: ['captions', 'speed', 'quality'],
    captions: { active: false },
    storage: { enabled: false }
};

function VodPlayerWrapper(
    {
        recordUrls,
        autoplay = true,
        hlsEnabled = true,
        overridePlayerConfigs,
        children,
        userId,
        userEmail,
        sessionId,
        sessionTitle,
        muxEnvKey,
        streamType,
        captionsEnabled,
        turnOnCaptionsForAttendees,
        captionTracksAvailable
    }
) {
    const playerConfigs = {
        ...initialPlayerConfigs,
        ...overridePlayerConfigs,
        captions: { active: captionsEnabled && turnOnCaptionsForAttendees },
        storage: { enabled: captionsEnabled }
    };

    const versionToScriptUrls = {
        plyr: FeatureToggleUtils.getFeatureValue('bap-plyr-io-version'),
        hls: FeatureToggleUtils.getFeatureValue('bap-hls-js-version'),
        mux: FeatureToggleUtils.getFeatureValue('bap-mux-player-version'),
    };

    const bizzaboAgnosticPlayer = FeatureToggleUtils.getFeatureValue('bizzabo-agnostic-player');

    if (bizzaboAgnosticPlayer === 'mux' && !captionTracksAvailable) {
        return (
            <MuxPlayer
                recordUrls={recordUrls}
                autoplay={autoplay}
                MutedOverlayComponent={<MutedPreviewOverlay IconComponent={VolumeMuteOutlineIcon}/>}
                versionToScriptUrls={versionToScriptUrls}
                streamType={streamType} // Mux player stream type - defines controls, and requests or prevents some logic in MuxPlayer component
                userId={userId}
                userEmail={userEmail}
                sessionId={sessionId}
                sessionTitle={sessionTitle}
                muxEnvKey={muxEnvKey}
                captionsEnabled={captionsEnabled}
                showCaptionsByDefault={captionsEnabled ? turnOnCaptionsForAttendees : false}
            >
                {children}
            </MuxPlayer>
        );
    }
    return (
        <BizzaPlyr
            playerConfigs={playerConfigs}
            recordUrls={recordUrls}
            hlsEnabled={hlsEnabled}
            autoplay={autoplay}
            MutedOverlayComponent={<MutedPreviewOverlay IconComponent={VolumeMuteOutlineIcon}/>}
            versionToScriptUrls={versionToScriptUrls}
            captionsEnabled={captionsEnabled}
        >
            {children}
        </BizzaPlyr>
    );
}

export default React.memo(VodPlayerWrapper);
